<op-dynamic-form
  [formUrl]="formUrl"
  [fieldsSettingsPipe]="dynamicFieldsSettingsPipe"
  [fieldGroups]="fieldGroups"
  (submitted)="onSubmitted($event)"
  helpTextAttributeScope="Project"
></op-dynamic-form>